import { buildMessage, registerDecorator } from 'class-validator';
import { DateTime } from 'luxon';
export function isDateTimeFormat(value, options) {
    if (options.isInterval) {
        const parts = value
            .split('/')
            .map((element) => element.trim())
            .filter(Boolean);
        if (parts.length !== 2) {
            return false;
        }
        const [start, end] = parts;
        const startDateTime = DateTime.fromFormat(start, options.format);
        const endDateTime = DateTime.fromFormat(end, options.format);
        return startDateTime.isValid && endDateTime.isValid && startDateTime < endDateTime;
    }
    return DateTime.fromFormat(value, options.format).isValid;
}
export function IsDateTimeFormat(options, validationOptions) {
    return (object, propertyName) => {
        registerDecorator({
            name: isDateTimeFormat.name,
            target: object.constructor,
            propertyName: propertyName.toString(),
            constraints: [],
            options: validationOptions,
            validator: {
                validate(value) {
                    return typeof value === 'string' && isDateTimeFormat(value, options);
                },
                defaultMessage: buildMessage((eachPrefix) => {
                    const expectedFormat = options?.isInterval ? `${options.format}/${options.format}` : options.format;
                    return `${eachPrefix}$property must be of format ${expectedFormat}`;
                }, validationOptions),
            },
        });
    };
}
//# sourceMappingURL=IsDateTimeFormat.js.map